module.exports = __webpack_public_path__ + "static/media/down-chevron.b913f381.svg";